// Optimal-zone shading / grouping is only meaningful when a channel's four region
// boundaries strictly ascend. Degenerate series (e.g. [0,0,0,0] or [0,1,1,2]) collapse
// one or more zones to zero width.
export function regionsStrictlyIncreasing (regions) {
  for (let i = 1; i < regions.length; i++) {
    if (regions[i] <= regions[i - 1]) {
      return false
    }
  }
  return true
}
